/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * used for service health level report
 */ 
export enum HealthErrorCodes {
    Undefinded = 0,
    NotReachable = 1,
    AudiodeviceNotRunning = 2,
    HttpApiHostNotRunning = 3,
    WebsocketServerNotRunning = 4,
    DataFolderNotFound = 5,
    IsRepatching = 6,
    InvalidChannelMapping = 7,
    InvalidFrameSize = 8,
    LowDiskSpace = 9,
    InvalidChannelMapping_Channel_Number_Less_Than_Zero = 10,
    InvalidChannelMapping_Channel_Number_Exceeds_Set_Limit = 11,
    InvalidChannelMapping_Channel_Number_Exceeds_Audio_Meter = 12,
    AsteriskAudioSocketNotRunning = 13,
    InvalidChannelMapping_Duplicate_Input_Channels = 14,
    InvalidChannelMapping_Duplicate_Output_Channels = 15,
    InvalidChannelMapping_Duplicate_Phone_Channels = 16,
    TesiraInsufficientDynamicAudioInputChannels = 17,
    TesiraInsufficientDynamicAudioOutputChannels = 18,
    HighLatency = 19,
    DVSNotRunning = 20,
    FFmpegNotFound = 21,
    VersionMismatch = 22,
}
